import React from 'react'
import Backdrop from './Backdrop'

interface ConfirmModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  confirmText?: string
  onConfirm: () => void
  variant?: 'default' | 'destructive'
}

export default function ConfirmModal({
  open,
  onOpenChange,
  title,
  description,
  confirmText = 'Confirm',
  onConfirm,
  variant = 'default',
}: ConfirmModalProps) {
  const handleConfirm = () => {
    onConfirm()
    onOpenChange(false)
  }

  if (!open) return null

  const isDestructive = variant === 'destructive'

  return (
    <Backdrop onClose={() => onOpenChange(false)}>
      <div
        style={{
          background: 'var(--white)',
          borderRadius: 20,
          width: 400,
          maxWidth: '94vw',
          boxShadow: 'var(--sh-lg)',
          overflow: 'hidden',
          animation: 'mIn .4s cubic-bezier(.16,1,.3,1) both',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: '20px 26px 16px',
            borderBottom: '1px solid var(--bd2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
          }}
        >
          <div>
            <h3
              style={{
                fontFamily: "'Playfair Display',serif",
                fontSize: 17,
                fontWeight: 500,
                color: 'var(--navy)',
              }}
            >
              {title}
            </h3>
            <p style={{ fontSize: 11.5, color: 'var(--muted)', marginTop: 2 }}>
              {description}
            </p>
          </div>
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            style={{
              width: 28,
              height: 28,
              borderRadius: 7,
              border: '1px solid var(--bd)',
              background: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 15,
              color: 'var(--muted)',
            }}
          >
            ✕
          </button>
        </div>
        <div
          style={{
            padding: '14px 26px 20px',
            borderTop: '1px solid var(--bd2)',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
          }}
        >
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            style={{
              padding: '7px 16px',
              borderRadius: 9,
              border: '1px solid var(--bd)',
              background: 'transparent',
              fontSize: 12.5,
              fontWeight: 500,
              color: 'var(--muted)',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            style={{
              padding: '7px 16px',
              borderRadius: 9,
              border: 'none',
              background: isDestructive ? 'var(--error)' : 'var(--navy)',
              fontSize: 12.5,
              fontWeight: 500,
              color: 'var(--white)',
              cursor: 'pointer',
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Backdrop>
  )
}
